(() => {
  const source = document.getElementById('AlsBundleProductGuideData');
  const main = document.getElementById('MainContent');
  if (!source || !main) return;

  const content = JSON.parse(source.textContent);
  const addText = (element, value) => {
    element.textContent = value;
    return element;
  };

  const presetPrices = new Map();
  const pendingPresets = new Set();
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: content.currency
  }).format(cents / 100);

  const variantPrices = new Map((content.eligibleVariants || []).map((variant) => [String(variant.id), variant.price]));
  const updateText = (node, value) => {
    if (node && node.textContent !== value) node.textContent = value;
  };
  // Own the preview nodes, leaving Loop's React-managed prices and cart logic intact.
  const previewPrice = (host, original, discounted) => {
    if (!host) return;
    let preview = host.querySelector(':scope > .als-loop-preview-price');
    if (!preview) {
      preview = document.createElement('span');
      preview.className = 'als-loop-preview-price';
      preview.append(document.createElement('s'), document.createElement('strong'));
      host.appendChild(preview);
    }
    updateText(preview.querySelector('s'), original > discounted ? money(original) : '');
    updateText(preview.querySelector('strong'), money(discounted));
  };

  const enhanceOffer = () => {
    const hero = main.querySelector('.loop-bundle-image-container-wrapper');
    const template = document.getElementById('AlsBundleOfferTemplate');
    if (hero && template && !hero.querySelector('.als-loop-offer')) {
      hero.appendChild(template.content.cloneNode(true));
      hero.classList.add('als-loop-offer-ready');
    }
    updateText(main.querySelector('.loop-bundle-select-product-title-new'), content.offer.chooseItems);
    const oneTime = main.querySelector('[aria-label="Select one-time purchase"]');
    const subscription = main.querySelector('[aria-label="Select subscription"]');
    updateText(subscription?.querySelector('.loop-bundle-widget-selling-plan-text'), content.offer.subscriptionLabel);
    const selected = Array.from(main.querySelectorAll('.loop-selected-variant-container'));
    const lines = selected.map((item) => ({
      item, price: variantPrices.get(item.dataset.variantId), quantity: Number(item.querySelector('input')?.value || 0)
    }));
    const count = lines.reduce((total, line) => total + line.quantity, 0);
    const known = lines.every((line) => Number.isInteger(line.price) && line.quantity > 0);
    const rate = count >= 3 ? 10 : count === 2 ? 5 : 0;
    const unitPrice = (price) => price - Math.floor(price * rate / 100);
    const isOneTime = oneTime?.classList.contains('selected') || false;
    main.classList.toggle('als-loop-onetime', isOneTime);
    main.classList.toggle('als-loop-pricing-ready', known);
    oneTime?.classList.toggle('als-loop-one-time-option', known);

    const info = main.querySelector('.loop-selected-bundle-info');
    if (info) {
      let progress = info.querySelector('.als-loop-progress-copy');
      if (!progress) {
        progress = document.createElement('strong');
        progress.className = 'als-loop-progress-copy';
        info.prepend(progress);
      }
      const subRate = count >= 5 ? 30 : count >= 4 ? 25 : 20;
      updateText(progress, count < 2 ? content.offer.startProgress :
        (isOneTime ? content.offer.oneTimeProgress : content.offer.subscriptionProgress).replace('__RATE__', isOneTime ? rate : subRate));
    }
    if (!known || !oneTime) return;
    const original = lines.reduce((total, line) => total + line.price * line.quantity, 0);
    const discounted = lines.reduce((total, line) => total + unitPrice(line.price) * line.quantity, 0);
    previewPrice(oneTime.querySelector('.loop-bundle-widget-selling-plan-price-container'), original, discounted);
    let saving = oneTime.querySelector('.als-loop-once-saving');
    if (!saving) {
      saving = document.createElement('span');
      saving.className = 'als-loop-once-saving';
      oneTime.appendChild(saving);
    }
    updateText(saving, rate ? content.offer.oneTimeSaving.replace('__RATE__', rate) : '');

    const totalHost = main.querySelector('.loop-display-saved-total');
    if (totalHost) {
      let total = totalHost.querySelector('.als-loop-once-total');
      if (!total) {
        total = document.createElement('span');
        total.className = 'als-loop-once-total';
        total.append(document.createElement('strong'), document.createElement('small'));
        totalHost.appendChild(total);
      }
      updateText(total.querySelector('strong'), content.offer.subtotalLabel.replace('__PRICE__', money(discounted)));
      updateText(total.querySelector('small'), rate ? content.offer.savedLabel.replace('__PRICE__', money(original - discounted)) : '');
    }
    const widget = main.querySelector('.loop-bundle-widget-container');
    if (widget && !widget.querySelector('.als-loop-price-note')) {
      const note = addText(document.createElement('p'), content.offer.priceNote);
      note.className = 'als-loop-price-note';
      widget.appendChild(note);
    }
    lines.forEach(({item, price, quantity}) => previewPrice(item.querySelector('.loop-selected-variant-price-container'), price * quantity, unitPrice(price) * quantity));
    main.querySelectorAll('.loop-bundle-product-card[data-variant-id]').forEach((card) => {
      const price = variantPrices.get(card.dataset.variantId);
      if (Number.isInteger(price)) previewPrice(card.querySelector('.loop-display-product-price'), price, unitPrice(price));
    });
  };

  const enhancePresetOffer = () => {
    const selected = Array.from(main.querySelectorAll('.loop-selected-variant-container'));
    const existing = main.querySelector('.als-loop-preset-offer');
    const handles = selected.map((item) => item.dataset.productHandle).sort();
    const singleQuantities = selected.every((item) => Number(item.querySelector('input')?.value) === 1);
    const preset = singleQuantities && content.presets?.find((set) => set.available &&
      set.components.length === handles.length && [...set.components].sort().every((handle, index) => handle === handles[index]));
    if (!preset) {
      existing?.remove();
      return;
    }
    const host = main.querySelector('.loop-selected-bundle-items-count');
    if (!host) return;
    let offer = existing;
    if (offer?.dataset.handle !== preset.handle) {
      offer?.remove();
      offer = document.createElement('aside');
      offer.className = 'als-loop-preset-offer';
      offer.dataset.handle = preset.handle;
      offer.appendChild(addText(document.createElement('strong'), content.matchingSetTitle.replace('__SET__', preset.title)));
      const prices = document.createElement('p');
      prices.dataset.presetPrices = '';
      offer.appendChild(prices);
      const link = addText(document.createElement('a'), content.viewSetLabel.replace('__SET__', preset.title));
      link.href = preset.url;
      offer.appendChild(link);
      host.insertAdjacentElement('afterend', offer);
    }
    if (presetPrices.has(preset.handle)) {
      const price = presetPrices.get(preset.handle);
      if (!price) return;
      const labels = [];
      if (Number.isFinite(price.oneTime) && price.oneTime > 0) labels.push(content.oneTimeLabel + ' · ' + money(price.oneTime));
      if (Number.isFinite(price.subscription) && price.subscription > 0) labels.push(content.monthlyLabel + ' · ' + money(price.subscription));
      const priceNode = offer.querySelector('[data-preset-prices]');
      const text = labels.join(' / ');
      if (priceNode.textContent !== text) priceNode.textContent = text;
    } else if (!pendingPresets.has(preset.handle) && typeof window.alsGetPresetBundlePrices === 'function') {
      pendingPresets.add(preset.handle);
      window.alsGetPresetBundlePrices(preset).then((price) => presetPrices.set(preset.handle, price))
        .catch(() => presetPrices.set(preset.handle, null)).finally(scheduleEnhancement);
    }
  };

  const enhance = () => {
    enhanceOffer();
    const heading = main.querySelector('.loop-bundle-select-product-title-new-container');
    if (heading && !heading.querySelector('.als-loop-selection-intro')) {
      const intro = addText(document.createElement('p'), content.intro);
      intro.className = 'als-loop-selection-intro';
      heading.appendChild(intro);
    }
    if (heading && !heading.querySelector('.als-loop-set-pricing-note')) {
      const note = addText(document.createElement('p'), content.setPricingNote + ' ');
      note.className = 'als-loop-set-pricing-note';
      const link = addText(document.createElement('a'), content.setLinkLabel);
      link.href = '/collections/wellness-bundles';
      note.appendChild(link);
      heading.appendChild(note);
    }

    main.querySelectorAll('.loop-bundle-product-card[data-product-handle]').forEach((card) => {
      const title = card.querySelector('.loop-bundle-product-card-title');
      const image = card.querySelector('.loop-bundle-product-image-container img');
      if (title && image && !image.alt) image.alt = title.textContent.trim();

      if (card.querySelector('.als-loop-product-guide')) return;
      const product = content.products[card.dataset.productHandle];
      const body = card.querySelector('.loop-product-card-description-body');
      if (!product || !body) return;

      const guide = document.createElement('div');
      guide.className = 'als-loop-product-guide';
      if (product.name) {
        card.classList.add('als-loop-profile');
        const name = addText(document.createElement('h3'), product.name);
        name.className = 'als-loop-product-name';
        const identity = addText(document.createElement('p'), product.identity);
        identity.className = 'als-loop-product-identity';
        guide.append(name, identity);
      }


      const bestFor = document.createElement('p');
      bestFor.className = 'als-loop-best-for';
      bestFor.append(
        addText(document.createElement('span'), product.name ? content.formulaLabel : content.bestForLabel),
        addText(document.createElement('strong'), product.bestFor)
      );

      const summary = addText(document.createElement('p'), product.summary);
      summary.className = 'als-loop-product-summary';

      const details = document.createElement('ul');
      details.className = 'als-loop-product-details';
      details.setAttribute('aria-label', content.keyDetailsLabel);
      product.details.filter(Boolean).forEach((detail) => {
        details.appendChild(addText(document.createElement('li'), detail));
      });

      guide.append(bestFor, summary, details);
      body.insertBefore(guide, body.querySelector('.loop-display-product-price'));
    });

    main.querySelectorAll('.loop-selected-variant-container').forEach((item) => {
      const title = item.querySelector('.loop-selected-variant-title');
      const image = item.querySelector('img');
      if (title && image && (!image.alt || image.alt === 'Default Title')) {
        image.alt = title.textContent.trim();
      }
    });

    if (document.documentElement.lang.startsWith('en')) {
      main.querySelectorAll('.loop-selected-bundle-info p, .loop-selected-bundle-items-count p').forEach((element) => {
        const corrected = element.textContent.replace('1 items', '1 item');
        if (element.textContent !== corrected) element.textContent = corrected;
      });
    }
    enhancePresetOffer();
  };

  let scheduled = false;
  const scheduleEnhancement = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      enhance();
    });
  };

  enhance();
  main.addEventListener('click', scheduleEnhancement);
  main.addEventListener('change', scheduleEnhancement);
  new MutationObserver(scheduleEnhancement).observe(main, { childList: true, characterData: true, subtree: true });
})();
